import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {  NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ToasterModule, ToasterService} from 'angular2-toaster';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
//import { ToastrModule } from 'ngx-toastr';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { DxDropDownBoxModule, DxTextBoxModule } from 'devextreme-angular';
//import {DxSchedulerModule} from 'devextreme-angular';
import { DxMenuModule, DxSelectBoxModule, DxCheckBoxModule } from 'devextreme-angular';
import { DxDateBoxModule, DxRadioGroupModule, DxRadioGroupComponent } from 'devextreme-angular';
//import { DxChartModule, DxDropDownBoxModule, DxTagBoxModule, DxDataGridModule, DxDraggableModule } from 'devextreme-angular';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { CdTimerModule } from 'angular-cd-timer';
//import { NgOtpInputModule } from 'ng-otp-input';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { FormsModule } from '@angular/forms';
import { DxAutocompleteModule,DxTagBoxModule, DxAccordionModule,DxPopoverModule, DxFilterBuilderModule, DevExtremeModule, DxDataGridModule, DxBulletModule, DxTemplateModule, DxNumberBoxModule, DxHtmlEditorModule,DxCalendarModule, DxTreeListModule  } from 'devextreme-angular';
//import {  CommonModule } from '@angular/common';

import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { HttpClientModule } from '@angular/common/http';
import { LoginWithOtpComponent } from './components/login-with-otp/login-with-otp.component';
import { LoginWithPasswordComponent } from './components/login-with-password/login-with-password.component';
import { SelectMallComponent } from './components/select-mall/select-mall.component';
import { VerifyOtpComponent } from './components/verify-otp/verify-otp.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { SocialSigninRegisterNumberComponent } from './components/social-signin-register-number/social-signin-register-number.component';
import { SocialSigninVerifyOtpComponent } from './components/social-signin-verify-otp/social-signin-verify-otp.component';
import { LoginOldComponent } from './components/login-old/login-old.component';
import { SignupOldComponent } from './components/signup-old/signup-old.component';
import { SocialSigninRegisterNumberOldComponent } from './components/social-signin-register-number-old/social-signin-register-number-old.component';
import { SocialSigninSelectMallComponent } from './components/social-signin-select-mall/social-signin-select-mall.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    //DxValidatorComponent,
    //DxValidationGroupComponent,
    LoginWithOtpComponent,
    LoginWithPasswordComponent,
    SelectMallComponent,
    VerifyOtpComponent,
    SetPasswordComponent,
    SocialSigninRegisterNumberComponent,
    SocialSigninVerifyOtpComponent,
    LoginOldComponent,
    SignupOldComponent,
    SocialSigninRegisterNumberOldComponent,
    SocialSigninSelectMallComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    ToasterModule.forRoot(),
    //ToastrModule.forRoot(),
    DxButtonModule,                                                   
    DxTextBoxModule,
    DxToolbarModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxValidatorModule,
    HttpClientModule,
    CdTimerModule,
    DxRadioGroupModule,
    NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
    NgxUiLoaderModule,
    //NgOtpInputModule,
    //DxScrollViewModule,
    //CommonModule,
    FormsModule,
    DxAutocompleteModule,
    DxTagBoxModule, 
    DxAccordionModule,
    DxPopoverModule, 
    DevExtremeModule, 
    DxNumberBoxModule, 
    DxCalendarModule, 
    DxDropDownBoxModule,
    DxCheckBoxModule,
   
    DxDropDownBoxModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
